import React from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { helpers } from "@shared";

const PaymentMethodOptions = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const next = () => {
        helpers.navigateNext(location, navigate);
    };

    return (
        <div className="page-content-wrapper">
            <h1 className="page-header">Your connection options</h1>
            <div className="page-subheader font-black text-black">Choose to add your checking or savings account or you can add it manually using your routing and account number</div>
            <button type="button" className="btn btn-primary" onClick={next}>Continue</button>
        </div>
    );
};

export default PaymentMethodOptions;
